import { z } from 'zod'
import {
  FeeMarketEIP1559TxData,
  TransactionFactory,
  TypedTransaction,
} from '@ethereumjs/tx'
import { Common } from '@ethereumjs/common'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { ChainID } from '@lukso/controllerapps-sharedlogic-primitives'

import { TransactionData } from './TransactionData'
import { GasLimit } from './GasLimit'
import { To } from './To'
import { TransactionValue } from './TransactionValue'
import { Nonce } from './Nonce'
import { MaxPriorityFeePerGas } from './MaxPriorityFeePerGas'
import { MaxFeePerGas } from './MaxFeePerGas'
import { Type } from './Type'

const TransactionRequestPropsSchema = z.object({
  gasLimit: z.instanceof(GasLimit),
  type: z.instanceof(Type),
  maxPriorityFeePerGas: z.instanceof(MaxPriorityFeePerGas),
  maxFeePerGas: z.instanceof(MaxFeePerGas),
  to: z.instanceof(To),
  data: z.instanceof(TransactionData),
  value: z.instanceof(TransactionValue),
  nonce: z.instanceof(Nonce),
  chainID: z.instanceof(ChainID),
})

type TransactionRequestProps = z.infer<typeof TransactionRequestPropsSchema>

export class TransactionRequest extends ValueObject<TransactionRequestProps> {
  public getTypedTransaction(): TypedTransaction {
    const {
      to,
      data,
      value,
      nonce,
      gasLimit,
      maxPriorityFeePerGas,
      maxFeePerGas,
      chainID,
      type,
    } = this.props

    return TransactionFactory.fromTxData(
      {
        gasLimit: gasLimit.getHexValue(),
        type: type.getHexValue(),
        maxPriorityFeePerGas: maxPriorityFeePerGas.getValue(),
        maxFeePerGas: maxFeePerGas.getValue(),
        to: to.getChecksumValue(),
        data: data.getHexValue(),
        value: value.getHexValue(),
        nonce: nonce.getHexValue(),
      } as FeeMarketEIP1559TxData,
      {
        common: Common.custom({ chainId: chainID.toNumber() }),
      }
    )
  }

  public static create(props: TransactionRequestProps): TransactionRequest {
    const validatedProps = TransactionRequestPropsSchema.parse(props)
    return new TransactionRequest(validatedProps)
  }
}
